import React, { useContext, useEffect, useState, useCallback } from 'react';
import Listing from '../../components/Listing';
import { useLocation } from 'react-router';
import useFetch from '../../hooks/useFetch';
import config from '../../config';
import { CurrentTeamContext } from '../../contexts/CurrentTeamContext';
import { RightSidebarContext } from '../../contexts/RightSidebarContext';
import { useModalsGlobal } from '../../hooks/useModalsGlobal';

export default function TeamDispatch() {
	const { teamState } = useContext(CurrentTeamContext);
	const { rightSidebarDispatch } = useContext(RightSidebarContext);
	const { data, fetch, reqLoading, setData } = useFetch();

	const { showModal } = useModalsGlobal();

	let location = useLocation();

	const [loading, setLoading] = useState(false);
	const [search, setSearch] = useState(null);
	const [pages, setPages] = useState(0);
	const [filter, setFilter] = useState({
		limit: 7,
		skip: 0,
		pages: 0,
		sort: 'date.desc',
	});

	const options = {
		rightGroup: [{ text: '12 months' }, { text: '30 days' }, { text: '1 week' }, { text: '24 hours' }],
		leftGroup: [{ text: 'All Trades' }, { text: 'Purchases' }, { text: 'Sales' }],
	};

	function openPackageCreateModal(packages) {
		showModal('createPackage', {
			callback: (e) => {
				if (e?.data?.data) {
					setData((data) => [e.data.data, ...data]);
				}
			},
			data: packages,
			submitUrl: `${config.apiv1}/package/package.create`,
			method: 'POST',
		});
	}

	function openCourierCreateModal(packages) {
		showModal('createCourier', {
			submitUrl: `${config.apiv1}/courier/courier.create`,
			method: 'POST',
		});
	}

	function handlePagination(data) {
		let selected = data.selected;
		let newSkip = Math.ceil(selected * filter?.limit);
		setLoading(true);
		handleFilter(newSkip, 'skip');
	}

	function resetPagination() {
		let paginationBtns = document.getElementsByClassName('paginationPage');
		for (let i = 0; i < paginationBtns.length; i++) {
			paginationBtns[i]?.classList.remove('paginationActive');
		}
		paginationBtns[0]?.classList.add('paginationActive');
	}

	function handleFilter(value, name) {
		if (name === 'status') {
			rightSidebarDispatch({ type: 'SET_CONTENT_REFERENCE', payload: { status: value } });
		}
		if (name !== 'skip') {
			resetPagination();
		}

		setFilter((filter) => ({
			...filter,
			[name]: value,
		}));
	}

	const updateDebounceSearch = useCallback(
		debounce((searchValue) => {
			setSearch(searchValue);
		}),
		[]
	);

	function openFilter() {
		const contentType = 3;
		rightSidebarDispatch({ type: 'SET_TEXTBOXES_CLOSED' });
		rightSidebarDispatch({ type: 'SET_CONTENT_REFERENCE', payload: { status: filter?.status || presetStatus } });
		rightSidebarDispatch({
			type: 'SET_CALLBACK',
			payload: (filter) => {
				handleFilter(filter);
				rightSidebarDispatch({ type: 'SET_SIDEBAR_OPEN', payload: false });
			},
		});
		rightSidebarDispatch({ type: 'SET_CONTENT_TYPE', payload: contentType });
		rightSidebarDispatch({ type: 'SET_SIDEBAR_OPEN', payload: true });
	}

	async function buildURLAndFetch() {
		setLoading(true);
		const url = new URL(`${config.apiv1}/package/packages.read/${teamState?.currentTeam?.teamUuid}`);

		filter?.sort?.split('.')[0] === 'date' && url.searchParams.set('sortDate', filter?.sort?.split('.')[1]);
		filter?.sort?.split('.')[0] === 'team' && url.searchParams.set('sortAlphabet', filter?.sort?.split('.')[1]);

		url.searchParams.set('matchRecipientUuid', teamState?.currentTeam?.teamUuid);

		filter?.member && url.searchParams.set('userUuid', filter?.member?.value);

		filter?.dateFrom && url.searchParams.set('dateFrom', filter?.dateFrom);
		filter?.dateTo && url.searchParams.set('dateTo', filter?.dateTo);
		search && url.searchParams.set('search', search);
		filter?.limit && url.searchParams.set('limit', filter?.limit);
		filter?.skip && url.searchParams.set('skip', filter?.skip);
		filter?.courier?.value && url.searchParams.set('courierUuid', filter?.courier?.value);

		let res = await fetch(url.href, null, true);

		if (res?.ok) {
			setPages(res?.data && res.data.length > 0 ? Math.ceil(res?.totalDocuments / filter?.limit) : 0);
		} else {
			setPages(1);
		}

		setLoading(false);
	}

	function debounce(cb, delay = 400) {
		let timeout;
		return (...args) => {
			setLoading(true);
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				cb(...args);
			}, delay);
		};
	}

	useEffect(() => {
		buildURLAndFetch(search);
	}, [teamState.reload, filter, search, location]);

	return (
		<Listing
			openFilter={openFilter}
			handlePagination={handlePagination}
			openPackageCreateModal={openPackageCreateModal}
			openCourierCreateModal={openCourierCreateModal}
			handleSearch={updateDebounceSearch}
			loading={reqLoading || loading}
			handleFilter={handleFilter}
			search={search}
			options={options}
			listItems={data ? data : null}
			filter={filter}
			pages={pages}
			type='packages'
		/>
	);
}
